/**
 * Labstep
 *
 * @module core/HorizontalTable
 * @desc Table by row
 */

import classnames from 'classnames';
import { Hoverable } from 'labstep-web/core/Hoverable';
import type React from 'react';
import { Table } from 'semantic-ui-react';
import styles from './styles.module.scss';
import type {
  IHorizontalTableBodyProps,
  TableHorizontalProps,
} from './types';

export const HorizontalTableBody: React.FC<
  IHorizontalTableBodyProps
> = ({ rows, columns, headerProps }) => (
  <Table.Body className={styles.body}>
    {rows.map((row, rowIndex) => (
      // FIXME react/no-array-index-key
      <Table.Row key={rowIndex} data-testid={row.dataTestId}>
        <Table.Cell
          style={{ fontWeight: 500 }}
          width={3}
          {...headerProps}
        >
          {row.header}
        </Table.Cell>
        {columns.map((entity, columnIndex) => {
          const cellComponent = // FIXME react/no-array-index-key
            (
              // FIXME react/no-array-index-key
              <Table.Cell key={columnIndex}>
                {row.content(entity) || ''}
              </Table.Cell>
            );
          return row.action ? (
            <Hoverable
              hoverable={cellComponent}
              component={row.action(entity)}
            />
          ) : (
            cellComponent
          );
        })}
      </Table.Row>
    ))}
  </Table.Body>
);

export const HorizontalTable: React.FC<TableHorizontalProps> = ({
  rows,
  columns,
  headerProps,
  borderless,
  dataCy,
  noMargin,
  ...rest
}) => {
  return (
    <Table
      data-cy={dataCy || 'core/Table/Horizontal'}
      className={classnames(styles.horizontalTable, {
        [styles.borderless]: borderless,
        [styles.noMargin]: noMargin,
      })}
      {...rest}
    >
      <HorizontalTableBody
        rows={rows}
        columns={columns}
        headerProps={headerProps}
      />
    </Table>
  );
};
